import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "flex-1"
};
const _hoisted_3 = {
  class: "font-bold"
};
const _hoisted_4 = {
  class: "flex-1"
};
const _hoisted_5 = {
  class: "flex-1 flex justify-end"
};
const _hoisted_6 = {
  key: 0,
  class: "flex items-center border-t mt-2 pt-2"
};
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import TerraceExpander from "@/modules/stadium/services/TerraceExpander";
import Icon from "@/modules/vue/components/Icon.vue";
import Stepper from "@/modules/vue/components/Stepper.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Terrace',
  props: {
    terrace: null
  },
  emits: ['entrance-fee-changed'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const onChangeFee = fee => emit('entrance-fee-changed', fee);
    const configRepository = app.get(ConfigRepository);
    const minFee = ref(configRepository.get('stadium.entranceFee.min'));
    const maxFee = ref(configRepository.get('stadium.entranceFee.max'));
    const step = ref(100);
    const confirmation = ref(null);
    const seatsTarget = ref(Math.min(props.terrace.seatsLimit, props.terrace.seats + step.value));
    const expandPrice = computed(() => configRepository.get('stadium.costs.terrace')(props.terrace, seatsTarget.value));
    const expandDuration = computed(() => configRepository.get('stadium.durations.terrace')(props.terrace, seatsTarget.value));
    const message = useMessage();
    const onClickExpand = () => {
      seatsTarget.value = Math.min(props.terrace.seatsLimit, props.terrace.seats + step.value);
      confirmation.value.confirm().then(async () => {
        if (seatsTarget.value <= props.terrace.seats) {
          return;
        }
        await app.get(TerraceExpander).queue(props.terrace, seatsTarget.value);
        message.success(translator.t('done'));
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["p-2 rounded", {
          'opacity-30 bg-slate-100': !__props.terrace.available,
          'bg-green-50': __props.terrace.available
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.terrace.type), 1), _createTextVNode(" " + _toDisplayString(__props.terrace.seats) + "/" + _toDisplayString(__props.terrace.seatsLimit), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('entrance_fee')), 1), _createVNode(Stepper, {
        "model-value": __props.terrace.entranceFee,
        min: minFee.value,
        max: maxFee.value,
        disabled: !__props.terrace.available,
        "onUpdate:modelValue": onChangeFee
      }, null, 8, ["model-value", "min", "max", "disabled"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_NButton, {
        type: "primary",
        disabled: !!__props.terrace.seatsFinishedAt || __props.terrace.seats >= __props.terrace.seatsLimit,
        onClick: onClickExpand
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('expand')), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(RichDialog, {
        ref_key: "confirmation",
        ref: confirmation,
        days: _unref(expandDuration),
        price: _unref(expandPrice),
        "confirmation-disabled": seatsTarget.value === __props.terrace.seats,
        "gate-type": _ctx.GateTypeEnum.BALANCE,
        "gate-value": _unref(expandPrice)
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('are_you_sure_want_to_develop_the_foundation?')), 1)]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('the_current_seat_capacity_will_not_be_available_during_expansion')) + " ", 1), _createVNode(FormGroup, {
          label: _ctx.$t('new_capacity')
        }, {
          default: _withCtx(() => [_createVNode(Stepper, {
            modelValue: seatsTarget.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => seatsTarget.value = $event),
            min: __props.terrace.seats,
            max: __props.terrace.seatsLimit,
            step: step.value
          }, null, 8, ["modelValue", "min", "max", "step"])]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 8, ["days", "price", "confirmation-disabled", "gate-type", "gate-value"])])]), __props.terrace.seatsFinishedAt ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(Icon, {
        icon: _ctx.IconEnum.ConstructionOutlined,
        class: "mr-4",
        size: "2rem"
      }, null, 8, ["icon"]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('development_ongoing_until_x', {
        date: _ctx.$date(__props.terrace.seatsFinishedAt)
      })) + " ", 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('target_seats', {
        seats: __props.terrace.seatsTarget
      })), 1)])])) : _createCommentVNode("", true)], 2);
    };
  }
});